import { TradingStrategySignalAction } from "../api/hooks/useSignals";

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * How a signal describes itself. Separate from the pages because the list, the details page and the
 * dashboard all say the same things about the same signal, and copies would drift.
 */

export function signalActionLabel(action: number, t: Translate): string {
  switch (action) {
    case TradingStrategySignalAction.Buy:
      return t("action.buy");
    case TradingStrategySignalAction.Exit:
      return t("action.exit");
    default:
      return t("action.unknown");
  }
}

/** How long a trade still open has been open so far. */
export function openFor(openedAt: string, t: Translate): string {
  return heldFor(openedAt, new Date().toISOString(), t);
}

/** How long a position was open: whole days, or hours or minutes inside the first day. */
export function heldFor(openedAt: string, closedAt: string, t: Translate): string {
  const minutes = Math.max(
    0,
    Math.floor((new Date(closedAt).getTime() - new Date(openedAt).getTime()) / 60_000),
  );
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days >= 1) {
    return t("detail.heldDays", { count: days });
  }

  if (hours >= 1) {
    return t("detail.heldHours", { count: hours });
  }

  if (minutes < 1) {
    return t("detail.heldUnderMinute");
  }

  return t("detail.heldMinutes", { count: minutes });
}
